<template>
    <div class="banner" :class="[ giftVoucherChristmasStyle ? 'christmas-banner' : 'normal-banner']">
        <div class="heading" v-html="$t('giftVoucher.bannerHeading')">
        </div>
        <div class="gift-voucher-description text-center d-mobile-none" v-html="$t('giftVoucher.bannerDescription')">
        </div>
        <div class="text-right">
            <a :href="giftVoucherProductUrl"
               class="btn btn-primary font-weight-normal">
                {{ $t('shop.buynow') }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GiftVoucherBanner',
    inject: ['giftVoucherProductUrl'],
    props: {
        giftVoucherChristmasStyle: {
            type: Boolean,
            required: false,
            default() {
                return false;
            },
        },
    },
};
</script>

<style lang="scss" scoped>
    .christmas-banner {
        background: transparent url('/assets/img/gift_voucher/banner_bg.jpg') no-repeat 50% 90%;
        @supports (background-image: url('/assets/img/gift_voucher/banner_bg.webp')) {
            background-image: url('/assets/img/gift_voucher/banner_bg.webp');
        }
        background-size: cover;
    }

    .normal-banner {
        .heading,
        .gift-voucher-description {
            color: var(--main-color);
        }
    }

    .normal-banner::after {
        content: '';
        position: absolute;
        background: transparent url('/assets/img/gift_voucher/normal_banner.jpg') no-repeat;
        @supports (background-image: url('/assets/img/gift_voucher/normal_banner.webp')) {
            background-image: url('/assets/img/gift_voucher/normal_banner.webp');
        }
        top: 0;
        z-index: -1;
        left: 0;
        background-size: cover;
        background-position-x: 100%;
        transform: scaleX(-1);
        opacity: 0.5;
        width: 100%;
        height: calc(100% - 20px);
        margin: 10px 0 10px 0;
    }

    @media (min-width: 769px) {
        .normal-banner::after {
            background-size: contain;
            transform: scaleX(1);
            background-position-x: 25%;
        }

        @media (min-width: 992px) {
            .normal-banner::after {
                background-position-x: 70%;
                opacity: 1;
                background-size: contain;
            }
        }
    }

    .banner {
        display: flex;
        position: relative;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: .5rem;

        border-radius: 10px;
        border: 2px solid var(--main-color);

        min-height: 110px;
        width: 100%;

        font-family: "Prompt", sans-serif;

        color: white;

        padding: 1.5rem;

        @media (max-width: 768px) {
            flex-direction: column;
            justify-content: center;
        }

        .heading {
            font-size: x-large;
        }

        .btn {
            width: 12.5ch;
        }
    }
</style>
